$( document ).ready(function() {
    if($('#masonry-gallery-filters li').length == 1) {
        $('#masonry-gallery-filters').hide();
    }

    /**
     * Masonry Gallery
     */

    var $masonryGalleryDownloads = $("#masonry-gallery-downloads");
    if ($masonryGalleryDownloads.length > 0) {
        $masonryGalleryDownloads.imagesLoaded( function() {
            $masonryGalleryDownloads.packery(
                {
                    itemSelector: '.gallery-downloads-item',
                    gutter: 10
                }
            );
        });
    }
});
